import React, { useEffect, useState } from "react";

import { ethers } from "ethers";
import axios from 'axios';
import { makeStyles } from '@material-ui/styles';

import { Provider as UseHttpProvider } from 'use-http';
import { ProductView } from "./ProductView";
import { HomeView } from "./HomeView";
import { DashboardView } from './DashboardView';
import {
  Switch,
  Route,
  useHistory,
  Redirect,
} from "react-router-dom";
import { AuthContext } from "./AuthContext";
import { Nav } from "./Nav";
import { Alert, CircularProgress, Container } from "@material-ui/core";
import { Toaster } from "react-hot-toast";
import { Footer } from "./Footer";
import { AuthenticatedRoute } from "./AuthenticatedRoute";
import { toast } from 'react-hot-toast';
import * as Sentry from '@sentry/react';
import detectEthereumProvider from '@metamask/detect-provider'
import { EditProductView } from "./EditProductView";

const network = process.env.REACT_APP_NETWORK;
const TransactArtifact = require(`../contracts/${network}/Transact.json`);
const contractAddress = require(`../contracts/${network}/contract-address.json`);

const ERROR_CODE_TX_REJECTED_BY_USER = 4001;
const BASE_URL = `${process.env.REACT_APP_API_URL}/v1`;

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 800,
  }
}));

const getToken = () => {
  try {
    const payload = JSON.parse(window.localStorage.getItem('cryptobroadway'));
    if (payload?.tokens?.access?.token) {
      const { expires, token } = payload.tokens.access;
      const currentTime = new Date().getTime();
      const expiryUnix = Date.parse(expires);
      return currentTime < expiryUnix ? token : null;
    }
  } catch (error) {
    return null;
  }
}

export const Dapp2 = () => {
  //auth
  const [address, setAddress] = useState(undefined);
  const [token, setToken] = useState(getToken());
  const [loading, setLoading] = useState(true);

  //infra
  const [provider, setProvider] = useState();
  const [Transact, setTransact] = useState();
  const [metamask, setMetamask] = useState(false);

  //display
  const [userProducts, setUserProducts] = useState([]);
  const [purchasedProducts, setPurchasedProducts] = useState([]);
  const [products, setProducts] = useState([]);

  const history = useHistory();
  const classes = useStyles();

  // AUTH
  const connectWallet = async () => {
    const [userAddress] = await window.ethereum.enable();
    const addr = ethers.utils.getAddress(userAddress);
    setAddress(addr)

    return addr;
  };
  
  const login = async (address) => {
    const res = await window.ethereum.request({
      method: 'personal_sign',
      params: ["Login to Cryptobroadway", address, "password?"]
    });

    const rsp = await axios.post(`${BASE_URL}/auth/login`,
      {
        address,
        message: 'Login to Cryptobroadway',
        signature: res
      },
    );

    //todo: if this were pure it would just return `rsp.data` – later.
    setToken(rsp.data.tokens.access.token);
    window.localStorage.setItem('cryptobroadway', JSON.stringify({ ...rsp.data }));

    return rsp.data;
  };

  const resetState = () => {
    setAddress(undefined);
    setToken(undefined)
    localStorage.setItem('cryptobroadway', '{}');
  }

  const transferTokens = async (to, id, amount) => {
      const wei = ethers.utils.parseEther(amount.toString()).toString();
      return await Transact.purchase(to, id, { value: wei });
  }

  const onCreate = async (product) => {
    const formData = new FormData();
    Object.keys(product).forEach((key) => {
      if (product[key]) {
        formData.append(key, product[key]);
      }
    });

    const res = await axios.post(
      `${BASE_URL}/products`,
      formData, //todo: filter these keys
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    const { id } = res.data;
    history.push(`/products/${id}?newborn=true`);
  }

  const updateProduct = async (productId, payload) => {
    const formData = new FormData();
    Object.keys(payload).forEach((key) => {
      formData.append(key, payload[key]);
    });

    await axios.put(
      `${BASE_URL}/products/${productId}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    history.push(`/products/${productId}/edit`);
  }

  const purchase = async (product, statusCallback = toast) => {
    let tx = null;
    try {
      tx = await transferTokens(product.userId, product.id, product.price);
    } catch (error) {
      if (error.code === ERROR_CODE_TX_REJECTED_BY_USER) {
        statusCallback(null);
        return;
      }

      if (window.Sentry) {
        window.Sentry.captureException(tx);
      }
      console.error('contract action failed', tx)
      statusCallback('Transaction Failed');
      return;
    }

    const rsp = await axios.post(
      `${BASE_URL}/products/${product.id}/purchases`,
      {
        transaction: tx.hash
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    
    const { id: purchaseId } = rsp.data;

    let poll;
    const checkStatus = async () => {
      const statusRsp = await axios.get(
        `${BASE_URL}/products/${product.id}/purchases/${purchaseId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
      );

      if (!statusRsp.data) {
        return;
      }

      let msg = 'Unknown status';
      const { status, message } = statusRsp.data;
      switch(status) {
        case 'pending':
          msg = 'Waiting for transaction to settle...';
          break;
        case 'verified':
          msg = 'Transaction verified, enjoy!';
          clearInterval(poll);
          history.go(0);
          break;
        case 'expired':
          msg = 'Sorry, this transaction could not be verified with 2 hours. Please try again.';
          clearInterval(poll);
          break;
        case 'invalid':
          msg = 'The transaction submitted was invalid. ' + message || '';
          clearInterval(poll);
          break;
        default:
          console.error('unknown status received from api');
          clearInterval(poll);
      }

      statusCallback(msg);
    }

    poll = setInterval(checkStatus, 3000)
  }

  const onError = (error) => {
    toast(`Something went wrong ${error?.message ? ' : ' + error.message : ''}`)
  }

  //on init
  useEffect(() => {
    const fetchAccount = async () => {
      const eth = await detectEthereumProvider({ mustBeMetaMask: true });
      if (!eth) {
        setMetamask(false);
        setLoading(false);
        return;
      }
      setMetamask(true);

      const provider = new ethers.providers.Web3Provider(eth);
      setProvider(provider);
      const Transact = new ethers.Contract(
        contractAddress.Transact,
        TransactArtifact.abi,
        provider.getSigner(0)
      );
      setTransact(Transact);


      const [account] = await provider.listAccounts();
      if (account) {
        setAddress(ethers.utils.getAddress(account));
      }

      window.ethereum.on("accountsChanged", ([newAddress]) => {
        if (newAddress) {
          setAddress(ethers.utils.getAddress(newAddress));
          resetState();
        }
      });

      window.ethereum.on("chainChanged", ([networkId]) => {
        resetState();
        window.location.reload();
      });

      setLoading(false);
    };

    fetchAccount();
  }, []);

  if (loading) {
    return <CircularProgress style={{ position: 'absolute', top: '48%', left: '48%' }} />
  }

  return (
    <AuthContext.Provider value={{
      isLoggedIn: !!address && !!token,
      isConnected: address !== undefined,
      metamask,
      token,
      address,
      login,
      connect: connectWallet,
      logout: resetState
    }}>
      <UseHttpProvider
        url={BASE_URL}
        options={{
          headers: {
            Authorization: `Bearer ${token}`
          }
        }}
      >
        <Sentry.ErrorBoundary fallback={
          <Alert style={{ margin: '0 auto' }} variant="outlined" color="error">Something went wrong. I'd try refreshing.</Alert>
        }>
          <Nav />
          <Container className={classes.root}>
            <Toaster />
            <Switch>
              <AuthenticatedRoute path="/products/:productId/edit">
                <EditProductView onSave={updateProduct} />
              </AuthenticatedRoute>

              <Route path={"/products/:productId"}>
                <ProductView
                  token={token}
                  userAddress={address}
                  onSave={updateProduct}
                  onPurchase={purchase} />
              </Route>

              <AuthenticatedRoute path="/dashboard">
                <DashboardView
                  onCreate={onCreate}
                  userProducts={userProducts}
                  purchasedProducts={purchasedProducts}
                  onPurchase={purchase}
                  products={products}
                />
              </AuthenticatedRoute>

              <AuthenticatedRoute path="/logout" component={() => {
                resetState();
                return <Redirect to={{ pathname: "/" }} />
              }}>
              </AuthenticatedRoute>

              <Route path="/">
                <HomeView
                  onCreate={onCreate}
                  onPurchase={purchase}
                  products={products}
                />
              </Route>

            </Switch>
            <Footer />
          </Container>

        </Sentry.ErrorBoundary>
      </UseHttpProvider>
    </AuthContext.Provider>
  );
}
